<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>

</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'

export default {
  name: 'CityDistrict',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.district ? this.district.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.district ? this.district.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.district ? this.district.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  components: {
    MovieList,
    FixedPopup
  },
  data () {
    return {
      dorms: null,
      popupDorms: null,
      errors: [],
      district: null,
      url: '',
    }
  },
  methods: { 
upper () {
  const lower = this.$route.params.city
  const upper = lower.replace(/^\w/, c => c.toUpperCase());
  return upper;
},       
    getDorms () {
      let self = this
      axios.get(`/site/cities/dorms/${this.$route.params.city}?district=${this.$route.params.district}`)
        .then(response => {
          self.dorms = response.data.data.data
          self.district = response.data.district
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getDorms()
    this.url = window.location.origin + '/' + this.$route.params.city + '-movies/'
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style lang="scss">
</style>
